export const ROUTES_WITHOUT_WEATHER_EFFECTS = {
  story: 'story'
};
// use this value to calculate the "minWidth" and "minHeight" values
// of pixi-viewport`s clampZoom (it provides max scale functionality)
export const MIN_SIZES_SCALE_FACTOR = 6;
// use the offset to exclude the cutted bounds of tiled world
export const WORLD_BOUNDS_OFFSET = 100;
export const MOBILE_MEDIA_QUERY = 600;
